import { MessageCircle } from "lucide-react";
import { PERAHAN_INFO } from "@/lib/constants";

interface ProductCardProps {
  title: string;
  description: string;
  image: string;
}

export default function ProductCard({ title, description, image }: ProductCardProps) {
  const handleWhatsAppOrder = () => {
    const message = encodeURIComponent(`Hi! I'm interested in ordering the "${title}". Could you please provide more details?`);
    window.open(`https://wa.me/${PERAHAN_INFO.whatsapp.replace(/\D/g, '')}?text=${message}`, '_blank');
  };

  return (
    <div className="product-hover bg-[var(--perahan-ivory)] rounded-lg overflow-hidden shadow-lg">
      <img 
        src={image} 
        alt={`${title} - ${description}`}
        className="w-full h-80 object-cover"
        loading="lazy"
      />
      <div className="p-6">
        <h3 className="text-xl font-serif font-semibold text-[var(--perahan-charcoal)] mb-2">
          {title}
        </h3>
        <p className="text-[var(--perahan-gray)] mb-4">
          {description}
        </p>
        <button 
          onClick={handleWhatsAppOrder}
          className="w-full btn-terracotta flex items-center justify-center space-x-2"
        >
          <MessageCircle size={16} />
          <span>Order via WhatsApp</span>
        </button>
      </div>
    </div>
  );
}
